import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HubAuthProvider, useHubAuth } from './contexts/HubAuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import HubLogin from './pages/HubLogin';
import HubDashboard from './pages/HubDashboard';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useHubAuth();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
};

const AppRoutes: React.FC = () => {
  const { isAuthenticated } = useHubAuth();
  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <HubLogin />} />
      <Route path="/" element={<ProtectedRoute><HubDashboard /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

const App: React.FC = () => (
  <Router>
    <ThemeProvider>
      <HubAuthProvider>
        <AppRoutes />
      </HubAuthProvider>
    </ThemeProvider>
  </Router>
);

export default App;
